<template>
  <div class="multi-step-form new-login-wrapper">
    <transition :name="transitionName" mode="out-in">
      <div :key="currentStep">
        <div v-if="currentStep === 1" class="step step-1 active">
          <div class="">
            <div class="left-login">
              <div class="rep-icon-login">
                <img
                    src="../../assets/images/dashboard-rep.svg"
                    alt="image-fluid"
                />
              </div>
              <div class="">
                <router-link to="/smart-login">
                  <button class="qr-login-btn">
                    <img
                        src="../../assets/images/qr-icon.svg"
                        alt="qr icon"
                        class="me-2"
                    />Login with QR
                  </button>
                </router-link>
              </div>
            </div>
            <h4 class="login-title mb-2">Login to Continue</h4>

            <div class="auth-form pt-1 pb-3">
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <form @submit.stop.prevent="handleSubmit(checkEmailLogin)">
                  <custom-input-text
                      :rules="{ required: true, email: true }"
                      :customMessages="`Please enter your email address.`"
                      :customEmailMessage="`Please enter a valid email address`"
                      labelFor="Email"
                      labelName="Email"
                      inputName="Email"
                      formGroupClass="form-group mb-1"
                      placeholder="Please enter your email"
                      @emitChanges="resetErrorMsg"
                      :isErrorFlagSet="emailErrorFlag"
                      :vmodel.sync="form.username"
                  />
                  <div class="valid-error" v-if="emailErrorFlag">
                    {{ errorMsg }}
                  </div>
                  <button
                      class="submit-btn mt-3 next-btn"
                      type="submit"
                      :disabled="loginLoader"
                  >
                    <b-spinner v-if="loginLoader" small></b-spinner>
                    Next
                  </button>
                </form>
              </ValidationObserver>
            </div>
<!--            <p class="no-account mb-0">
              Don't have an account?
              <span class="login-highlight" @click="routeToSignup">Sign up</span>
            </p>-->
          </div>
        </div>

        <div v-if="currentStep === 2" class="step step-2 active">
          <div @click="goBack"> <h6 class="login-highlight">Back</h6></div>
          <div class="">
            <div class="left-login">
              <div class="rep-icon-login">
                <img
                    src="../../assets/images/dashboard-rep.svg"
                    alt="image-fluid"
                />
              </div>
              <div class="">
                <a href="/smart-login">
                  <router-link to="/smart-login">
                    <button class="qr-login-btn">
                      <img
                          src="../../assets/images/qr-icon.svg"
                          alt="qr icon"
                          class="me-2"
                      />Login with QR
                    </button>
                  </router-link>
                </a>
              </div>
            </div>
            <h4 class="login-title mb-0">Login to Continue</h4>
            <div class="auth-form pt-3 pb-3">
              <div class="email-change-wrap">
                <div class="">{{repEmail}}</div>
                <div class="login-highlight" @click="currentStep = 1">Change</div>
              </div>
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <form @submit.stop.prevent="handleSubmit(handleLogin)">
                  <label for="">Password<span class="required-label mt-2">*</span></label>
                  <div class="login-password-container">
                    <custom-input-text
                        :rules="{ required: true }"
                        :customMessages="`Please enter your password`"
                        labelFor=""
                        labelName="Password"
                        placeholder="Please enter your password"
                        :inputType='passwordType'
                        formGroupClass="form-group mb-1"
                        @emitChanges="resetErrorMsg"
                        :isErrorFlagSet="passwordErrorFlag"
                        :vmodel.sync="password"
                    />
                    <eye-button
                        id="password"
                        hideOnDefault="false"
                        :value="password"
                        class="login-toggle-eye-icon"
                        type="text"
                        @toggle="togglePasswordVisibility"
                    ></eye-button>
                    <div class="valid-error" v-if="passwordErrorFlag">
                      {{ errorMsg }}
                    </div>
                  </div>
                  <button class="submit-btn mt-3 next-btn" type="submit">
                    <b-spinner v-if="loginLoader" small></b-spinner>
                    Login
                  </button>
                </form>
              </ValidationObserver>
            </div>
            <div class="left-login mb-0">
              <div class="login-highlight" @click="generateOTP">
<!--                <b-spinner v-if="otpLoader && !(loginLoader)" small></b-spinner>
                Sign In using OTP-->
              </div>
              <router-link to="/forgot-password">
                <div class="login-highlight">
                  Forgot Password?
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import helper from "@/resource/Helper";

export default {
  name: 'MultiStepForm',
  data() {
    return {
      currentStep: 1,
      previousStepValue: 1,
      form: {
        username: "",
        deviceID: "",
      },
      password: '',
      loginLoader: false,
      otpLoader: false,
      emailErrorFlag: false,
      passwordErrorFlag: false,
      formErrors: [],
      errorMsg: '',
      passwordType: 'password',
      isPasswordVisible: true
    };
  },
  computed: {
    repEmail () {
      return this.$store.getters.repEmail
    },
    transitionName() {
      return this.currentStep === 1 ? "slide-right-fade" : "slide-left-fade";
    }
  },
  mounted() {
    let uniqueDeviceId = this.$store.getters.deviceId
        ? this.$store.getters.deviceId
        : this.$uuid.v1();
    this.form.deviceID = uniqueDeviceId;
    this.$store.commit("setDeviceId", uniqueDeviceId);
    this.form.username = this.$store.getters.repEmail
    this.checkRouteQuery();
    this.emailErrorFlag = false;
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
      this.passwordType = this.isPasswordVisible ? "text" : "password";
    },
    checkRouteQuery () {
      this.$route.query.step && (this.currentStep = parseInt(this.$route.query.step) || 1)
    },
    nextStep() {
      if (this.currentStep < 2) {
        this.currentStep++;
      }
    },
    checkEmailLogin() {
      let app = this;
      this.$store.commit("setAuthentication", false);
      app.loginLoader = true;
      app.$store.commit("setRepEmail", this.form.username);
      axios
          .post(app.$endpoint.API_EMAIL_VALIDATE_v4_URL, {
            email: app.form.username,
            device_id: app.form.deviceID,
          },)
          .then(function(response) {
            if (response.data.status == "success") {
              app.nextStep();
              app.loginLoader = false;
            }
          })
          .catch(function(error) {
            if (error.response.data.status == "error") {
              app.loginLoader = false;
              app.passwordErrorFlag = false;
              app.emailErrorFlag = true;
              app.errorMsg = error.response.data.message
            }
          });
    },
    handleLogin() {
      let app = this;
      this.$store.commit("setAuthentication", false);
      app.loginLoader = true;
      axios
          .post(app.$endpoint.API_LOGIN_V4_URL, {
            email: app.form.username,
            device_id: app.form.deviceID,
            password: app.password,
          },)
          .then(function(response) {
            if (response.data.status == "success") {
              app.generateOTP();
            }
          })
          .catch(function(error) {
            if (error.response.data.status == "error") {
              app.loginLoader = false;
              app.emailErrorFlag = false;
              app.passwordErrorFlag = true;
              app.errorMsg = error.response.data.message
            }
          });
    },
    resetErrorMsg () {
      let app = this
      app.passwordErrorFlag = false
      app.emailErrorFlag = false
      app.errorMsg = ''
    },
    generateOTP() {
      let app = this;
      app.$store.commit("setAuthentication", false);
      app.otpLoader = true;
      axios
          .post(app.$endpoint.API_V4_GENERATE_OTP, {
            email: app.form.username,
            device_id: app.form.deviceID,
            type: `both`
          })
          .then(function(response) {
            if (response.data.status == "success") {
              app.$router.push('/login-otp')
              helper.infoMessage(
                  app,
                  response.data.status,
                  response.data.message
              )
            }
            app.otpLoader = false;
            app.loginLoader = false;
          })
          .catch(function(error) {
            if (error.response.data.status == "error") {
              helper.infoMessage(
                  app,
                  error.response.data.status,
                  error.response.data.message
              );
            }
            app.otpLoader = false;
            app.loginLoader = false;
          });
    },
    routeToSignup () {
      let app = this
      app.$router.push('/registration')
    },
    goBack() {
      this.currentStep = 1
      this.$router.push({ path: '/login' })
    },
  },
};
</script>

<style>
.multi-step-form {
  margin: auto;
}

.multi-step-form .invalid-feedback {
  color: #E73737;
  background-color: #FFE9E9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.multi-step-form .step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.multi-step-form .step-indicator span {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.multi-step-form .step-indicator span.active {
  background-color: #007bff;
  color: white;
}

.multi-step-form  form {
  display: flex;
  flex-direction: column;
}

.multi-step-form label {
  margin-top: 10px;
}

.login-password-container {
  position: relative !important;
}

.login-toggle-eye-icon{
  position:absolute;
  top:10px;
  right:8px;
  cursor: pointer;
}


.login-password-container .is-valid {
  background-image: none !important;
}

.login-password-container .is-invalid {
  background-image: none !important;
}
.login-password-container .form-group{
        display: block !important;
}
</style>
  